export default __webpack_public_path__ + "static/media/ttweb-laptop.55d74de7.png";